import { decodeTagsParam } from '../../../helpers/decodeTagsParam'
import type { ConfigFilters } from '../../../types'

// Read the applied ConfigFilters out of the URL query string. The four column
// filters are stored under their API param names (an absent param means unset);
// tags is percent-decoded (see decodeTagsParam) back into `key:value` pairs.
// Inverse of buildConfigsSearchParams.
export function readConfigFiltersFromParams(
  params: URLSearchParams
): ConfigFilters {
  const tagsParam = params.get('tags')

  return {
    tenant: params.get('tenantCodes') ?? '',
    isp: params.get('inventorySystemProfileCodes') ?? '',
    venue: params.get('venueIds') ?? '',
    configKey: params.get('configKeys') ?? '',
    tags: tagsParam ? decodeTagsParam(tagsParam) : [],
  }
}
